import ANSWERS from '../constants/answers';

export const calculateResults = (answers, questions, likes) => {
  const count = Object.keys(answers || []).reduce(
    (total, questionId) => {
      const question = questions.find(it => it.id.toString() === questionId);
      const answer = answers[questionId];
      const { invertsAnswer } = question;
      const multiplier = likes[questionId] ? 2 : 1;

      const yesAnswer = invertsAnswer ? ANSWERS.NO : ANSWERS.YES;
      const noAnswer = !invertsAnswer ? ANSWERS.NO : ANSWERS.YES;
      return {
        ...total,
        ja: total.ja + multiplier * (answer === yesAnswer),
        nein: total.nein + multiplier * (answer === noAnswer)
      };
    },
    { ja: 0, nein: 0 }
  );
  const sum = count.ja + count.nein;
  const yesPercentage = Math.round(count.ja * (100 / sum));
  const noPercentage = Math.round(count.nein * (100 / sum));
  return { yesPercentage, noPercentage };
};

export const areAllQuestionsSkipped = answers =>
  Object.values(answers).every(it => it === ANSWERS.SKIP) || Object.keys(answers).length < 1;
